import { createSelector } from 'reselect';

export const getAttributeDefense = createSelector(
    [],
    () => {
        return 0;
    }
);
